module.exports = __webpack_public_path__ + "static/media/23-2.3ea93e61.mp3";